import { useMutation, ApolloError } from '@apollo/client'

import { SET_PROJECT_EMAIL_SETTINGS } from '@libs/apollo/mutations/project-email-settings.mutation'
import { FIND_PROJECT_EMAIL_SETTINGS } from '@libs/apollo/queries'

import { LocalFile, ProjectEmailSetSettingsInput } from '@types'

import { useCreateFile } from '../file/create-file.hook'

export const useSetProjectEmailSettings = (): {
  mutate: (input: ProjectEmailSetSettingsInput, file?: LocalFile) => Promise<void>
  loading: boolean
  error: ApolloError | undefined
} => {
  const { createFile } = useCreateFile()

  const [updateProjectEmailSettings, { loading, error }] = useMutation<
    boolean,
    { input: ProjectEmailSetSettingsInput }
  >(SET_PROJECT_EMAIL_SETTINGS)

  const mutate = async (input: ProjectEmailSetSettingsInput, file?: LocalFile) => {
    let newFileId: string | undefined

    if (file) {
      const remoteFile = await createFile(file)
      newFileId = remoteFile?.id
    }

    await updateProjectEmailSettings({
      variables: {
        input: {
          projectId: input.projectId,
          subjectPrefix: input.subjectPrefix,
          fileId: newFileId || input.fileId,
        },
      },
      refetchQueries: [
        {
          query: FIND_PROJECT_EMAIL_SETTINGS,
          variables: {
            projectId: input.projectId,
          },
        },
      ],
    })
  }

  return { mutate, loading, error }
}
